import { NavigationMenu } from "radix-ui";
import { FC } from "react";
import useAuthRoute from "~/hook/useAuthRoute";
import { useFontStyle } from "~/hook/useFontStyle";
import { cn } from "~/lib/utils";
import { BLUR_HASH, FALLBACK_IMAGE_URL } from "~/utils/constant";
import { formatName, wantsDesktop } from "~/utils/helper-funcations";
import ImageWithSkeleton from "../ImageWithSkeleton";
import { PropsType } from "../mobile-menu/type";

export const GRID_ITEMS: Record<string, string> = {
  narrow: "grid-cols-3",
  wide: "grid-cols-5",
};

export const ICON_ITEM_SHAPE: Record<string, string> = {
  circular: "rounded-full",
  rectangle: "rounded-lg",
  pentagon: "shape-pentagon",
};

const IconItem: FC<PropsType> = ({ data, category_name, displayItem, isImagePreloaded }) => {
  const { medium, regular } = useFontStyle();
  const { handleNavigate } = useAuthRoute();

  const handleItemClick = (navigateTo: string) => {
    handleNavigate(navigateTo);
  };

  return (
    <div className={cn("menu_parent_card", displayItem === "wide" ? "w-[500px]" : "w-[350px]", category_name ? "pt-5" : "pt-0")}>
      {category_name && (
        <div className="flex items-center justify-between mx-3  ">
          <h2 className={cn("icon_category_type", medium)}>{category_name}</h2>
        </div>
      )}

      <div className={cn("grid gap-y-2.5", GRID_ITEMS[displayItem])}>
        {data?.length > 0
          ? data?.map((item) => {
              const isVisible = wantsDesktop(item.show_menu);
              return (
                isVisible && (
                  <NavigationMenu.Link asChild key={item.id}>
                    <div
                      className="group flex flex-col items-center cursor-pointer transition-all duration-200 hover:scale-110"
                      onClick={() => handleNavigate(item.navigate_to)}
                      role="button"
                      tabIndex={0}
                      onKeyDown={(e) => {
                        if (e.key === "Enter" || e.key === " ") {
                          e.preventDefault();
                          handleItemClick(item.navigate_to);
                        }
                      }}
                    >
                      <div
                        className={cn(
                          // "w-full aspect-square overflow-hidden",
                          // ICON_ITEM_SHAPE[shape || "circular"]
                          "icon-menu-image-parent",
                        )}
                      >
                        <ImageWithSkeleton
                          url={{
                            small: typeof item.img === "string" ? item.img : item.img?.s?.url || FALLBACK_IMAGE_URL,
                            medium: typeof item.img === "string" ? item.img : item.img?.m?.url || FALLBACK_IMAGE_URL,
                            large: typeof item.img === "string" ? item.img : item.img?.l?.url || FALLBACK_IMAGE_URL,
                            hd: typeof item.img === "string" ? item.img : item.img?.hd?.url || FALLBACK_IMAGE_URL,
                            original: typeof item.img === "string" ? item.img : item.img?.og?.url || FALLBACK_IMAGE_URL,
                          }}
                          alt={item.name ?? "Icon"}
                          className="icon-menu-image"
                          loadImageLazy={false}
                          isPreloaded={isImagePreloaded?.(typeof item.img === "string" ? item.img : item.img?.s?.url || "") || false}
                          useSkeletonLoader={true}
                        />
                      </div>
                      <p
                        className={cn(
                          "icon_category_name text-center group-hover:text-dailyDarshanChipColor transition-colors line-clamp-2 w-full px-1",
                          regular,
                        )}
                        title={item.name}
                      >
                        {/* {formatName()} */}
                        {item.name}
                      </p>
                    </div>
                  </NavigationMenu.Link>
                )
              );
            })
          : null}
      </div>
    </div>
  );
};

export default IconItem;
